import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import AllRooms from "../../CustomComponents/Property/AllRooms/AllRooms";

function AllRoomsPage({ allPropertiesPage }) {
  return (
    <>
      {/* <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} /> */}

          <AllRooms />
        {/* </div>
      </div> */}
    </>
  );
}

export default AllRoomsPage;
